import * as React from "react"
import * as Antd from "antd"
import * as AntdIcons from "@ant-design/icons"
import styles from "./ChatWidget.module.scss"

import DsButton from "@components/general/DsButton/DsButton.tsx"
import PremiumAssistantChat from "@components/others/ChatWidget/PremiumAssistantChat/PremiumAssistantChat.tsx"

interface IProps {
	className?: string
}

const ChatWidget: React.FC<IProps> = (props) => {
	const [visible, setVisible] = React.useState(false)
	const [unreadMessages, setUnreadMessages] = React.useState(0)

	const handleChatButtonClick = () => {
		if (
			typeof Notification !== "undefined" &&
			Notification?.permission !== "granted"
		) {
			Notification.requestPermission().finally(() =>
				setVisible((lastSt) => !lastSt)
			)
		} else {
			setVisible((lastSt) => !lastSt)
		}
	}

	return (
		<div className={`${styles.chat_widget} ${props.className || ""}`}>
			<Antd.Badge
				count={unreadMessages}
				overflowCount={10}
				size={"small"}
			>
				<DsButton
					className={styles.chat_button}
					icon={<AntdIcons.MessageFilled />}
					onClick={handleChatButtonClick}
				/>
			</Antd.Badge>

			<PremiumAssistantChat
				visible={visible}
				className={styles.chat_container}
				onClose={() => setVisible(false)}
				onUnreadMessage={setUnreadMessages}
			/>
		</div>
	)
}

export default React.memo(ChatWidget)
